import React from 'react'
import close from "../assets/image/close.svg"

export default function ModalHeader({ closeModal, title }) {
    return (
        <div className='flex justify-between items-center mt-5 '>
            <h2 className='text-2xl'>{title}</h2>
            <div>
                <button className='transition-all p-2 bg-red-500 hover:bg-red-700 hover:scale-110 rounded-full' onClick={closeModal}>
                    <img src={close} alt="close" />
                </button>
            </div>
        </div>
    )
}


